// extracted by mini-css-extract-plugin
module.exports = {"container":"CardFallbackImage_container__BF8Tg","logo":"CardFallbackImage_logo__WqqOv"};